import { Injectable, OnDestroy } from '@angular/core';
import { AppMetadataHandler } from 'app/BaseFramework/configs/app-metadata.handler';
import { ApiRequestService, LookupDataService } from 'app/BaseFramework/core/http';
import { LiquidCache } from 'ngx-liquid-cache';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { CommonUtilty } from '../../utilities';

export interface currencyOptionsDO {
  prefix: string;
  thousands: string;
  decimal: string;
}


@Injectable({
  providedIn: 'root'
})
export class MultiTenancyConfigService implements OnDestroy {

  public DEFAULT_LANGUAGE_CODE: string = "EN";

  public masterTranslateLabel: { [key: string]: string } = {};
  public supportedLanguages: { [key: string]: any } = {
    'EN': { language: 'English', languageCd: 'EN', labelKey: {}, labelRes: [], missingLabelTranslation: [] },
    'ID': { language: 'Bahasa', languageCd: 'ID', labelKey: {}, labelRes: [], missingLabelTranslation: [] }
  };

  public currentLabelSelected: { [key: string]: string } = {};
  private _currentLanguageSelected: string = this.DEFAULT_LANGUAGE_CODE;

  public extractLabelFeature: boolean = false;
  public missingMasterTranslateLabelCd: Array<string> = [];

  public DEFAULT_CURRENCY_CODE: string = "INR";
  public DEFAULT_USER_CURRENCY_METADATA: { [key: string]: boolean } = {};
  public DEFAULT_CURRENCY_METADATA: { [key: string]: any } = {};


  constructor(private apiRequest?: ApiRequestService,
    private lookupDataService?: LookupDataService,
    private commonUtilities?: CommonUtilty,
    private AppMetaDataHandler?: AppMetadataHandler) { }

  ngOnDestroy(): void {
    throw new Error('Method not implemented.');
  }

  public set currentLanguageSelected(language: string) {
    if (language) {
      this._currentLanguageSelected = language;
    }
  }

  public get currentLanguageSelected() {
    return this._currentLanguageSelected;
  }

  setDefaultLanguage(masterLangCd?) {
    let APISubject: Subject<any> = new Subject<any>();
    let language = null;
    if (masterLangCd != null) {
      language = masterLangCd;
    }
    else {
      language = this.DEFAULT_LANGUAGE_CODE;
    }
    const has = Object.prototype.hasOwnProperty;
    let url = 'findByLanguageCd'
    let subscriptionLanguageLabel: Subscription;
    let pathVariables = [];
    pathVariables.push(language);
    subscriptionLanguageLabel = this.apiRequest.getCallWithAPIMapper(url, null, null, language)
      .subscribe(jsonResp => {
        let res = Object.assign([], jsonResp)
        for (let i = 0; i < res.length; i++) {
          if (has.call(this.supportedLanguages, res[i].language)) {
            this.masterTranslateLabel[res[i].labelValue] = res[i].labelKey;
          }
        }
        APISubject.next(jsonResp);

      });
    return APISubject;
  }

  setDefaultCurrency() {
    let APISubject: Subject<any> = new Subject<any>();
    /*let serviceURL = '';
    this.apiRequest.get(serviceURL).subscribe(jsonResponse =>{
      APISubject.next(jsonResponse);
    });*/
    this.DEFAULT_CURRENCY_CODE = 'INR';
    this.DEFAULT_USER_CURRENCY_METADATA = {
      prefix: true,
      miniSymbol: !this.DEFAULT_USER_CURRENCY_METADATA.prefix
    }
    this.DEFAULT_CURRENCY_METADATA[this.DEFAULT_CURRENCY_CODE] = {
      baseCurrencyPREFIX: this.DEFAULT_USER_CURRENCY_METADATA.prefix ? "INR" : "",
      baseCurrencyMiniPREFIX: this.DEFAULT_USER_CURRENCY_METADATA.miniSymbol ? "Rs" : "",
      DECIMAL_SEPARATOR: ".",
      THOUSANDS_SEPARATOR: ",",
      baseCurrencySUFFIX: ''
    };

    APISubject.next(this.DEFAULT_CURRENCY_CODE);
    return APISubject;
  }

  setLanguage(language: string): void {
    this.currentLanguageSelected = language;
    this.fetchLanguageLabelMap(language);
  }

  @LiquidCache('{langCd}')
  fetchLanguageSpecificLabels(langCd?): Subject<Array<any>> {
    let languageLabelSubject = new Subject<Array<any>>();
    let pathVariables = [];
    pathVariables.push(langCd);
    this.apiRequest.getCallWithAPIMapper('findByLanguageCd', null, null, pathVariables)
      .subscribe(jsonResp => {
        let res = Object.assign([], jsonResp);
        languageLabelSubject.next(res)
      }, error => {
        console.log("Error while fetching Language Label")
      })
    return languageLabelSubject;
  }


  fetchLanguageLabelMap(langCd?: string): void {
    if (!langCd) {
      langCd = this.DEFAULT_LANGUAGE_CODE;
    }
    const has = Object.prototype.hasOwnProperty;
    this.fetchLanguageSpecificLabels(langCd).subscribe(res => {
      for (var i = 0; i < res.length; i++) {
        if (has.call(this.supportedLanguages, res[i].language)) {
          this.supportedLanguages[res[i].language].labelKey[res[i].labelKey] = res[i].labelValue;
          this.supportedLanguages[res[i].language].labelRes.push(res[i]);
        }
      }

      this.currentLabelSelected = this.supportedLanguages[langCd].labelKey;
      console.log(this.currentLabelSelected);
    }, error => {
      console.log("Error while creating Language Label Map")
    })
  }


  translateLabel(label: string): string {
    const has = Object.prototype.hasOwnProperty;
    if (this.currentLabelSelected && has.call(this.masterTranslateLabel, label) && this.currentLanguageSelected != this.DEFAULT_LANGUAGE_CODE) {
      let labelCd = this.masterTranslateLabel[label];
      // return has.call(this.currentLabelSelected, labelCd) ? this.currentLabelSelected[labelCd] : label;
      if (has.call(this.currentLabelSelected, labelCd)) {
        return this.currentLabelSelected[labelCd];
      }
      else {
        this.commonUtilities.uniquePushInArray(this.supportedLanguages[this.currentLanguageSelected].missingLabelTranslation, label);
        // return label + "_" + this.currentLanguageSelected;
        return label;
      }
    }
    else {
      if (!has.call(this.masterTranslateLabel, label)) {
        this.commonUtilities.uniquePushInArray(this.missingMasterTranslateLabelCd, label);
      }
      // return label + "_" + this.currentLanguageSelected ;
      return label;
    }
  }


  // getSupportedLanguages() {

  //   let getLookupCd = "languageCd";
  //   let observableSupportedLanguage = this.lookupDataService.getLookup(getLookupCd);
  //   let subscriptionSupportedLanguage: Subscription;
  //   subscriptionSupportedLanguage = observableSupportedLanguage.subscribe(
  //     res => {
  //       let response: any[] = res;

  //       for (let lookupList of response) {
  //         if (lookupList[0].lookupCd == "languageCd") {
  //           // this.appMetadataHandler.supportedLanguages = lookupList
  //         }
  //       }
  //     },
  //     error => console.log('Error: ', error)
  //   );
  // }

  setApplicationCurrency() {
    let defaultAppCurrency: string = this.DEFAULT_CURRENCY_CODE;
    let allowPrefix: boolean = this.DEFAULT_USER_CURRENCY_METADATA.prefix;
    let allowMiniSymbol: boolean = this.DEFAULT_USER_CURRENCY_METADATA.miniSymbol;
    this.AppMetaDataHandler.allowedcurrencies = ['INR', 'IDR', 'SGD', 'USD', 'HK$', 'VND']
    this.AppMetaDataHandler.baseCurrencyPREFIX = allowPrefix ? this.DEFAULT_CURRENCY_METADATA[defaultAppCurrency].baseCurrencyPREFIX : "";
    this.AppMetaDataHandler.baseCurrencyMiniPREFIX = allowMiniSymbol ? this.DEFAULT_CURRENCY_METADATA[defaultAppCurrency].baseCurrencyMiniPREFIX : "";
    this.AppMetaDataHandler.DECIMAL_SEPARATOR = this.DEFAULT_CURRENCY_METADATA[defaultAppCurrency].DECIMAL_SEPARATOR
    this.AppMetaDataHandler.THOUSANDS_SEPARATOR = this.DEFAULT_CURRENCY_METADATA[defaultAppCurrency].THOUSANDS_SEPARATOR
    this.AppMetaDataHandler.baseCurrencySUFFIX = ''
  }

  setTransactionSpecificCurrency(transactionMetaData?: any) {
    if (transactionMetaData) {
      let currencyOption: currencyOptionsDO;
      const has = Object.prototype.hasOwnProperty;
      if (has.call(transactionMetaData, "currencyCd")) {
        if (transactionMetaData["currencyCd"]) {
          this.setCurrencySpecificMetaData(transactionMetaData["currencyCd"])
          currencyOption = {
            prefix: this.AppMetaDataHandler.baseCurrencyPREFIX,
            thousands: this.AppMetaDataHandler.THOUSANDS_SEPARATOR,
            decimal: this.AppMetaDataHandler.DECIMAL_SEPARATOR
          }
          this.AppMetaDataHandler.refreshTransactionSpecificCurrency$.next(currencyOption);
        }

      }
    }
  }

  setCurrencySpecificMetaData(currencyCd?: string) {
    // let allowPrefix: boolean = this.DEFAULT_USER_CURRENCY_METADATA.prefix;
    let allowPrefix: boolean = true;
    // let allowMiniSymbol: boolean = this.DEFAULT_USER_CURRENCY_METADATA.miniSymbol;
    let allowMiniSymbol: boolean = false;
    const has = Object.prototype.hasOwnProperty;
    if (currencyCd && has.call(this.AppMetaDataHandler.supportedCurrencyMaster, currencyCd)) {
      let currencyMeta = this.AppMetaDataHandler.supportedCurrencyMaster[currencyCd];
      this.AppMetaDataHandler.baseCurrencyPREFIX = allowPrefix ? currencyMeta.baseCurrencyPREFIX : "";
      this.AppMetaDataHandler.baseCurrencyMiniPREFIX = allowMiniSymbol ? currencyMeta.baseCurrencyMiniPREFIX : "";
      this.AppMetaDataHandler.DECIMAL_SEPARATOR = currencyMeta.DECIMAL_SEPARATOR
      this.AppMetaDataHandler.THOUSANDS_SEPARATOR = currencyMeta.THOUSANDS_SEPARATOR
      this.AppMetaDataHandler.baseCurrencySUFFIX = currencyMeta.baseCurrencySUFFIX
    }
  }


}
